const getAvatarPath = (imgName) => {
    const transformedName = imgName.toLowerCase().replace(/[^a-z0-9]/g, '_');
    const memberPhoto = global.MEMBER_PHOTO?.[transformedName];

    return memberPhoto && `/static/img/MemberPictures/${memberPhoto}`;
};

export default getAvatarPath;
